/**
 * Order payment choice enum, derived from VehiclePaymentSelection
 */
var OrderPaymentChoice;
(function (OrderPaymentChoice) {
    OrderPaymentChoice["FINANCING"] = "financing";
    OrderPaymentChoice["FULL_CASH"] = "full-cash";
})(OrderPaymentChoice || (OrderPaymentChoice = {}));

export { OrderPaymentChoice };
//# sourceMappingURL=OrderPaymentChoice.js.map
